import { createFileRoute } from '@tanstack/react-router'
import { CustomerCallBlocksPage } from '@/features/customer/call-blocks'

export const Route = createFileRoute('/_authenticated/customer/call-blocks')({
  component: CustomerCallBlocksPage,
})

